import React from 'react';

const MyBets = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.91406 7.50137C4.91406 4.69314 7.19058 2.41663 9.9988 2.41663C12.807 2.41663 15.0835 4.69314 15.0835 7.50137C15.0835 9.43398 14.0049 11.1161 12.4159 11.9762V8.3349C12.4159 6.99999 11.3337 5.91783 9.9988 5.91783C8.66389 5.91783 7.58173 6.99999 7.58173 8.3349V11.9762C5.99268 11.1161 4.91406 9.43398 4.91406 7.50137ZM6.87383 14.1581L7.21725 13.4713C4.97127 12.423 3.41406 10.1448 3.41406 7.50137C3.41406 3.86472 6.36215 0.916626 9.9988 0.916626C13.6355 0.916626 16.5835 3.86472 16.5835 7.50137C16.5835 9.08853 16.0222 10.544 15.0874 11.6807C15.9169 13.5244 16.0739 15.6113 15.5137 17.5723L15.057 19.1707H13.7566L14.3115 17.2288C14.7465 15.7063 14.6755 14.0949 14.1273 12.6312C13.4701 13.1607 12.7092 13.5665 11.8798 13.8133C11.6529 13.8809 11.4073 13.8373 11.2175 13.6957C11.0277 13.5542 10.9159 13.3313 10.9159 13.0945V8.3349C10.9159 7.82842 10.5053 7.41783 9.9988 7.41783C9.49232 7.41783 9.08173 7.82842 9.08173 8.3349V12.9193C9.08173 13.0358 9.05463 13.1506 9.00255 13.2548L8.21547 14.8289C7.68884 15.8822 7.41467 17.0436 7.41467 18.2212V19.1708H5.91467V18.2212C5.91467 16.8107 6.24306 15.4196 6.87383 14.1581Z",
      fill: "white"
    }
  )
);

export { MyBets };
//# sourceMappingURL=MyBets.js.map
